import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { WebhooksPathName, WebhooksRoute } from '@/modules/ta/webhooks/webhooks.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${WebhooksRoute.WEBHOOKS}`,
      name: WebhooksPathName.WEBHOOKS,
      component: () => import(/* webpackChunkName: "webhooks-page" */ './pages/WebhooksPage.vue'),
    },
    {
      path: `/${WebhooksRoute.WEBHOOKS}/new`,
      name: WebhooksPathName.NEW,
      component: () =>
        import(/* webpackChunkName: "webhooks-form-page" */ './pages/WebhooksFormPage.vue'),
      props: true,
    },
    {
      path: `/${WebhooksRoute.WEBHOOKS}/:id`,
      name: WebhooksPathName.EDIT,
      component: () =>
        import(/* webpackChunkName: "webhooks-form-page" */ './pages/WebhooksFormPage.vue'),
      props: true,
    },
    {
      path: `/${WebhooksRoute.WEBHOOKS}/:id/history`,
      name: WebhooksPathName.HISTORY,
      component: () =>
        import(/* webpackChunkName: "webhooks-history-page" */ './pages/WebhooksHistoryPage.vue'),
      props: true,
    },
  ],
  Module.WEBHOOKS
);
